export const TherapistAssignmentRole = {
  MainTherapist: "main_therapist",
  SubstituteTherapist: "substitute_therapist",
} as const;

export type TherapistAssignmentRole = typeof TherapistAssignmentRole[keyof typeof TherapistAssignmentRole];

export const isTherapistAssignmentRole = (value: unknown): value is TherapistAssignmentRole =>
  value === TherapistAssignmentRole.MainTherapist || value === TherapistAssignmentRole.SubstituteTherapist;
